import { List } from '@mui/material';
import type { FC } from 'react';
import { useState } from 'react';
import type { Member } from '../../models/member';
import { ConversationMemberItem } from './conversation-member-item';
import { ConversationMemberMenu } from './conversation-member-menu';

interface MemberListProps {
  convId: string;
  members: Member[];
  memberCount: number;
  curUser: Member;
}

export const MemberList: FC<MemberListProps> = ({ convId, members, curUser }) => {
  const [contextMenu, setContextMenu] = useState<{
    mouseX: number;
    mouseY: number;
  } | null>(null);
  const [selectedMember, setSelectedMember] = useState<Member | null>(null);

  const handleContextMenu = (event: React.MouseEvent<HTMLElement>, member: Member) => {
    event.preventDefault();
    setContextMenu(
      contextMenu === null
        ? {
            mouseX: event.clientX + 2,
            mouseY: event.clientY - 6
          }
        : null
    );
    setSelectedMember(member);
  };

  const handleClose = () => {
    setContextMenu(null);
    setSelectedMember(null);
  };

  return (
    <>
      <List sx={{ py: 0 }}>
        {(members || []).map((member) => (
          <ConversationMemberItem key={member.userId} member={member} onRightClick={handleContextMenu} />
        ))}
      </List>
      <ConversationMemberMenu
        convId={convId}
        contextMenu={contextMenu}
        selectedMember={selectedMember}
        curUser={curUser}
        onClose={handleClose}
      />
    </>
  );
};
